import React from 'react'
import { observer } from 'mobx-react'
import useSelection from '../hooks/use-selection'
import useValue from '../hooks/use-value'
import { useWillPipe } from '@morningtrain/react-helpers'

function SelectOnPipe ({
  multiple = true
}) {
  const selection = useSelection()
  const modelKeyName = selection.modelKeyName
  const modelKey = useValue(modelKeyName)

  useWillPipe((payload) => {
    return new Promise(((resolve, reject) => {
      if (!modelKey) {
        return reject()
      }

      if (multiple === false) {
        selection.clearSelected()
      }

      selection.add(modelKey)

      resolve(payload)
    }))
  }, [selection, modelKey, multiple])

  return null
}

export default observer(SelectOnPipe)
